import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const vulFacilityStatusRepository = RepositoryFactory.get("vulFacilityStatus");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setVulFacilityStatus(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadVulFacilityStatus(context, payload) {
    const list = await vulFacilityStatusRepository.list(
      payload.screenId,
      payload.municipality,
      payload.disasterNo
    );
    if (list.status < 300) {
      context.commit("setVulFacilityStatus", list.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
